import { get } from "@insite/client-framework/Services/ApiService";
import { SessionModel } from "@insite/client-framework/Types/ApiModels";

const sessionsUrl = "/api/v1/sessions";

export async function getCurrentSession() {
    const result = await get<SessionModel>(`${sessionsUrl}/current`, {});
    return result;
}
